import React, { useEffect, useState } from "react";

// components
import Tooltip from "../tooltip/tooltip";

// Styles
import CommonStyles from "../shared.module.scss";
import Styles from "./input.module.scss";
import Information from "../svg/information";
import CrossSvg from "../svg/cross";

function Input({
  hasError,
  id,
  isValid = null,
  tooltipMessage = null,
  showInfo = false,
  requiredAstrict,
  customInputClass,
  name,
  value,
  onChange,
  clear = true,
  isMandatory = false,
  ...props
}: any) {
  const [inputValue, setInputValue] = useState<any>(value || "");
  const resolvedId = id || (name ? `z-input-${name}` : undefined);
  const testId = props["data-testid"] ?? resolvedId;
  const clearId = `input-${name}`;
  const shownValue = value || inputValue;

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <div>
      {props.labelname && (
        <label
          htmlFor={props.labelName}
          className={`${CommonStyles.formLabel} `}
        >
          <div
            className={`d-flex align-items-center ${
              requiredAstrict ? Styles.required : null
            }`}
          >
            {props.labelname}
            {isMandatory && (
              <span className={`${Styles.mandatoryField}`}>*</span>
            )}
            {showInfo ? (
              <div className="px-2">
                <Tooltip placement="right" title={tooltipMessage}>
                  <div
                    className={`d-flex align-items-center justify-content-center ${Styles.InfoIconBack}`}
                  >
                    <Information infoClass={Styles.infoIcon} />
                  </div>
                </Tooltip>
              </div>
            ) : null}
          </div>
        </label>
      )}
      <div className={"position-relative"}>
        <input
          className={`${CommonStyles.commonInputClass} ${
            hasError !== ""
              ? CommonStyles.error
              : isValid
                ? CommonStyles.valid
                : CommonStyles.formControl
          } ${props.noshadow && "shadow-none"} ${customInputClass || ""} ${Styles.inputValue} ${
            shownValue?.length && clear ? Styles.inputWithClear : ""
          }`}
          name={name}
          value={shownValue}
          onChange={(e) => {
            onChange(e);
            setInputValue(e.target.value);
          }}
          {...props}
          id={resolvedId}
          data-testid={testId}
        />
        <div className={Styles.indicator}>
          {shownValue?.length && clear ? (
            <div
              id={clearId}
              data-testid={clearId}
              className="px-2"
              style={{ cursor: "pointer" }}
              onClick={() => {
                onChange({ target: { value: "" } });
                setInputValue("");
              }}
            >
              <CrossSvg width="10" height="10" />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Input;
